import { Slugs } from '@/modules/Leads/constants/Routing';

export const isAnUnpaidAppPath = (path: string = ''): boolean =>
  Object.values(Slugs).some((wl) => path.includes(wl));

export default null;
